export const AppUrls = {
    base: '/',
    login: '/login',
    passwordRecovery: '/password-recovery',
    resetPassword: '/reset-password',
    recents: '/recents',
    dialpad: '/dialpad',
    contacts: '/contacts/:slug',
    settings: '/settings',
    account: '/settings/account',
    changePassword: '/settings/account/change-password',
    soundAndDevices: '/settings/sound-and-devices',
    callPreferences: '/settings/call-preferences',
    help: '/settings/help',
    about: '/settings/about',
    integration: '/settings/integration',
    call: '/call/:slug',
    conference: '/conference',
    keypad: '/keypad',
    logout: '/logout',
    callTo: '/callTo=',
    microphonePermissionDenied: '/error/microphone-permission-denied',
    connectionLost: '/error/connection-lost',
    multipleTabsError: '/error/multiple-tabs',
    callerInsights: '/callerInsights',
    tokenLogin: '/auth'
}
